export default {
    LIQUIDATION_ROTATION: "LIQUIDATION_ROTATION",
    LIQUIDATION_MONTHLY: "LIQUIDATION_MONTHLY"
};